import { formatMoney } from "@/scripts/global/utils/helpers"

import Alpine from "alpinejs"
import focus from "@alpinejs/focus"
import intersect from '@alpinejs/intersect'

import swiper from "@/scripts/components/swiper"
import { Accordion } from "../../scripts/components/accordion"
import backInStosk from "@/scripts/templates/product/backInStosk"
import splideSlider from "@/scripts/components/splide-slider";
import cart from "@/scripts/templates/cart/cart";
import CustomDrawer from "@/scripts/components/drawer"
import imageBanner from "@/scripts/sections/image_banner";
import newNavigation from "@/scripts/sections/new-navigation"
import MobileCustomDrawer from "@/scripts/components/mobile-bottom-drawer"
import ARProductComponent from "@/scripts/components/ar-component"
import ArDesktopModal from "@/scripts/components/ar-desktop-modal"
import ARHelper from "@/scripts/components/ar-helper"
import membership from "@/scripts/sections/membership"
import artistsCarousel from "@/scripts/components/artists-carousel";
import { initAlpineUtils } from "../../scripts/global/utils/alpine"
import { initAnalytics } from "../../scripts/global/utils/analytics"
import { Filter } from "./templates/collection/filter"
import { GenericSlider } from "../../scripts/components/generic-slider"

Alpine.plugin([ focus, intersect ])
window.Alpine = Alpine
window.formatMoney = formatMoney

document.addEventListener("alpine:init", () => {
  Alpine.store("globalState", {
    mainMenuIsOpen: false,
    mobileMenuIsOpen: false
  })
  Alpine.data("imageBanner", imageBanner);
  Alpine.data("newNavigation", newNavigation);
  Alpine.data("swiper", swiper)
  Alpine.store("cart", cart())
  Alpine.data("Accordion", Accordion)
  Alpine.data("backInStosk", backInStosk)
  Alpine.store("membership", membership())
  Alpine.data("splide", splideSlider)
  Alpine.data("customDrawer", new CustomDrawer)
  Alpine.data("mobileCustomDrawer", new MobileCustomDrawer)
  Alpine.data('ARProductComponent', ARProductComponent);
  Alpine.data('ARDesktopModal', ArDesktopModal);
  Alpine.data("artistsCarousel", artistsCarousel);
  Alpine.store("Filter", Filter());
  Alpine.data("GenericSlider", GenericSlider);
  initAlpineUtils();
})

Alpine.start()

new ARHelper
document.addEventListener("DOMContentLoaded", initAnalytics);